import React, { SVGProps } from 'react';

export default function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="icon_twitter"
      height="24"
      viewBox="0 0 375 375"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      fill="0F1618"
      {...props}
    >
      <g>
        <path fill="#000" d="M187 7a180 180 0 1 0 0 361 180 180 0 0 0 0-361" />
      </g>
      <g transform="translate(90 85)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="199.8"
          height="199.8"
          className="icon-svg"
          viewBox="0 0 24 24"
        >
          <path fill="#fff" d="M18 2h4l-8 9 9 11h-7l-5-7-6 7H2l7-9L1 2h7l5 6zm-1 18h2L7 4H5z" />
        </svg>
      </g>
    </svg>
  );
}
